import { EGerdauService } from '../EGerdauService';
import {
  IDestination,
  ILongSteelOrderItem,
  IItemSaleInfo,
  ILongSteelShoppingCartState
} from '../../store/ducks/long-steel-shopping-cart/types';
import { ELocalStorageKey, ILocalStorageObj } from '../EGerdauService/types';
import {
  customersAuthorizationApi,
  ECustomerAuthorizationEndpoints
} from '../api';

export interface ILongSteelShoppingCartService {
  localStorageKey: ELocalStorageKey;
  canReturnLocalStorageData(localStorageData: ILocalStorageObj): boolean;
  sendOrder(
    items: ILongSteelOrderItem[],
    emitterId: string,
    receiverId: string,
    customerOrder: string
  ): Promise<string[]>;
}

export class LongSteelShoppingCartService
  extends EGerdauService
  implements ILongSteelShoppingCartService
{
  readonly localStorageKey = ELocalStorageKey.LONG_STEEL_SHOPPING_CART;

  getLongSteelShoppingCartFromLocalStorage(): ILongSteelShoppingCartState {
    const localStorageData = super.getLocalStorage(this.localStorageKey);

    return localStorageData && this.canReturnLocalStorageData(localStorageData)
      ? localStorageData.obj
      : { items: [], emitterId: '', receiverId: '', customerOrder: '' };
  }

  canReturnLocalStorageData(localStorageData: ILocalStorageObj): boolean {
    const now = new Date();
    return now.getTime() - localStorageData.dateTime <= 3600000; // 1h
  }

  updateShoppingCartStateLocalStorage(
    longSteelShoppingCartState: ILongSteelShoppingCartState
  ): void {
    super.setLocalStorage(this.localStorageKey, longSteelShoppingCartState);
  }

  async sendOrder(
    items: ILongSteelOrderItem[],
    emitterId: string,
    receiverId: string,
    customerOrder: string
  ): Promise<string[]> {
    const headers = super.getHeaders();

    const itemsSaleInfo: IItemSaleInfo[] = items.map((item) => {
      const selectedDestination: IDestination = {
        ...(item.itemSaleInfo.selectedDestination as IDestination)
      };

      delete item.itemSaleInfo.selectedDestination;
      delete item.itemSaleInfo.minimumQuantity;
      delete item.itemSaleInfo.multipleQuantity;

      return {
        ...item.itemSaleInfo,
        plant: Number(selectedDestination.plant),
        salesGroup: selectedDestination.salesGroup,
        salesOffice: selectedDestination.salesOffice,
        salesOrg: selectedDestination.salesOrg,
        distrChannel: Number(selectedDestination.distributionChannel),
        activitySector: selectedDestination.division,
        industrialType: selectedDestination.condGroup,
        consumptionOrder:
          selectedDestination.description === 'Consumo' ? 'X' : undefined
      };
    });

    const response = await customersAuthorizationApi.post(
      `${ECustomerAuthorizationEndpoints.SEND_ORDER}?customer=${emitterId}`,
      {
        items: itemsSaleInfo,
        soldTo: emitterId,
        shipTo: receiverId,
        purchaseNumber: customerOrder
      },
      { headers }
    );

    const createdOrders: string[] = [];
    response.data.orders.forEach((order: { order: string }) => {
      createdOrders.push(order.order);
    });

    this.updateShoppingCartStateLocalStorage({
      items: [],
      emitterId: '',
      receiverId: '',
      customerOrder: '',
      typeOfOrder: '',
      screenName: '',
      itemDescription: ''
    });
    return createdOrders;
  }
}
